import {useEffect, useState} from 'react';
import {Switch} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {Layout, Space, Spin} from 'antd';
import {Route} from 'react-router-dom';
import {Authenticator} from '@aws-amplify/ui-react';
import {SignInInput} from 'aws-amplify/auth';

import {getCurrentUserPermission} from '../utils';
import {SchoolEdit} from '../modules/Schools/SchoolEdit';
import {SiderComponent} from './';
import {
  EnrollmentsTable,
  EnrollmentDetails,
  EnrollmentCreate,
  EnrollmentEdit,
  StudentDetails,
  StudentsTable,
  TestDetails,
  TestsTable,
  Dashboard,
  PlanDetails,
  PlanEdit,
  TestCreate,
  PackagesTable,
  PackageDetails,
  PackageEdit,
  PackageCreate,
  PriceCreate,
  PriceEdit,
  PricesTable,
  StudentEdit,
  ProgramsTable,
  ProgramEdit,
  LevelsTable,
  LevelCreateEdit,
  TestEdit,
  AddingRole,
  StudentSessionDetails,
  UserDetails,
  DiscountCodeTable,
  SchoolsTable,
  CurriculumCreate,
  CurriculumEdit,
  CurriculumsTable,
  StudentReport,
  PlacementTestCreate,
  PlacementTestsTable,
  PlacementTestDetails,
  PlacementTestEdit,
  StoryTable,
  StoryCreate,
  StoryEdit,
} from '../modules';
import {doSignIn} from '../redux/actions/user';
import {DiscountCodeForPartnerTable} from '../modules/DiscountCodeForPartner';
import {DiscountCodeForPartnerDetails} from '../modules/DiscountCodeForPartner/DiscountCodeForPartnerDetails';
import {SchoolCreate} from '../modules/Schools/SchoolCreate';
import {PlanTableContainer} from '../modules/Plans/PlanTableContainer';
import {PlanCreate} from '../modules/Plans/PlanCreate';

const {Content} = Layout;

export const Routers = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state: any) => state.user.isLoggedIn);

  const isLoading = useSelector((state: any) => state.user?.isLoading);

  const [currentUserPermission, setCurrentUserPermission] = useState<any>();
  const renderPartnersRoutes = () => {
    return (
      <>
        <Route exact path="/partners">
          <DiscountCodeForPartnerTable />
        </Route>
        <Route path="/discount-code-details">
          <DiscountCodeForPartnerDetails />
        </Route>
      </>
    );
  };

  const renderEditorsRoutes = () => {
    return (
      <>
        {/** Enrollments routes*/}
        <Route exact path="/enrollments">
          <EnrollmentsTable />
        </Route>
        <Route path="/enrollments/create">
          <EnrollmentCreate />
        </Route>
        <Route exact path="/enrollments/:enrollmentId">
          <EnrollmentDetails />
        </Route>
        <Route exact path="/school/:schoolId/edit">
          <SchoolEdit />
        </Route>

        <Route exact path="/enrollments/:enrollmentId/edit">
          <EnrollmentEdit />
        </Route>

        {/** Students routes*/}
        <Route exact path="/students">
          <StudentsTable />
        </Route>
        <Route exact path="/students/:studentId">
          <StudentDetails />
        </Route>
        <Route exact path="/students/:studentId/edit">
          <StudentEdit />
        </Route>
        <Route exact path="/student-sessions/:studentId">
          <StudentSessionDetails />
        </Route>
        <Route exact path="/students/:studentId/report/:statisticId">
          <StudentReport />
        </Route>

        {/** DiscountCodes routes*/}
        <Route exact path="/discountcodes">
          <DiscountCodeTable />
        </Route>
        {/** user routes*/}
        <Route path="/users/:userId">
          <UserDetails />
        </Route>
      </>
    );
  };

  const renderContentCreatorRoutes = () => (
    <Switch>
      <Route exact path="/tests">
        <TestsTable />
      </Route>
      <Route exact path="/tests/create">
        <TestCreate />
      </Route>
      <Route path="/tests/:testId">
        <TestDetails />
      </Route>
      <Route path="/test/:testId/edit">
        <TestEdit />
      </Route>
    </Switch>
  );
  const renderAdminRoutes = () => (
    <>

      {/** Plans routes*/}
      <Switch>
        <Route exact path="/plans">
          <PlanTableContainer />
        </Route>
        <Route exact path="/plans/create">
          <PlanCreate />
        </Route>
        <Route exact path="/plans/:planId">
          <PlanDetails />
        </Route>
        <Route exact path="/plans/:planId/edit">
          <PlanEdit />
        </Route>
      </Switch>
      {/** Tests routes*/}
      <Switch>
        <Route exact path="/tests">
          <TestsTable />
        </Route>
        <Route exact path="/tests/create">
          <TestCreate />
        </Route>
        <Route path="/tests/:testId">
          <TestDetails />
        </Route>
        <Route path="/test/:testId/edit">
          <TestEdit />
        </Route>
      </Switch>
      {/** Placement Tests routes*/}
      <Switch>
        <Route exact path="/placement-tests">
          <PlacementTestsTable />
        </Route>
        <Route exact path="/placement-tests/create">
          <PlacementTestCreate />
        </Route>
        <Route path="/placement-tests/:placementTestId/edit">
          <PlacementTestEdit />
        </Route>
        <Route path="/placement-tests/:testId">
          <PlacementTestDetails />
        </Route>
      </Switch>
      {/** Packages routes*/}
      <Route exact path="/packages">
        <PackagesTable />
      </Route>
      <Route path="/package/create">
        <PackageCreate />
      </Route>
      <Route exact path="/packages/:packageId">
        <PackageDetails />
      </Route>
      <Route path="/packages/:packageId/edit">
        <PackageEdit />
      </Route>
      {/** Packages routes*/}
      {/** Prices routes*/}
      <Route exact path="/prices">
        <PricesTable />
      </Route>
      <Route path="/prices/create">
        <PriceCreate />
      </Route>
      <Route exact path="/prices/:priceId/edit">
        <PriceEdit />
      </Route>

      {/** Program routes*/}
      <Route exact path="/programs">
        <ProgramsTable />
      </Route>
      <Route exact path="/programs/:programId/edit">
        <ProgramEdit />
      </Route>


      {/** Levels routes*/}
      <Route exact path="/levels">
        <LevelsTable />
      </Route>
      <Route path="/levels/create">
        <LevelCreateEdit />
      </Route>
      <Route exact path="/levels/:levelId/edit">
        <LevelCreateEdit />
      </Route>

      {/** schools routes*/}
      <Route exact path="/schools">
        <SchoolsTable />
      </Route>
      <Route path="/schools/create">
        <SchoolCreate />
      </Route>

      {/** accounts routes*/}
      <Route path="/accounts/role">
        <AddingRole />
      </Route>

      {/** Curriculums routes*/}
      <Route exact path="/curriculums">
        <CurriculumsTable />
      </Route>

      <Route path="/curriculums/create">
        <CurriculumCreate />
      </Route>
      <Route exact path="/curriculums/:curriculumId/edit">
        <CurriculumEdit />
      </Route>

      {/** Story routes */}
      <Switch>
        <Route exact path="/stories">
          <StoryTable />
        </Route>
        <Route exact path="/stories/create">
          <StoryCreate />
        </Route>
        <Route exact path="/stories/:storyId">
          <StoryEdit />
        </Route>
        <Route exact path="/stories/:storyId/edit">
          <StoryEdit />
        </Route>
      </Switch>


    </>
  );

  const services = {
    async handleSignIn(input: SignInInput): Promise<any> {
      // custom username and email
      const {username, password} = input;

      console.log('username', username);
      dispatch(doSignIn(username, password));

      return;
    },
  };

  useEffect(() => {
    if (isLoggedIn) {
      getCurrentUserPermission()
        .then((p: any) => {
          setCurrentUserPermission(() => p);
          console.log('isLoggedIn000', p);
        })
        .catch((er) => {
          console.log('err->', er);
        });
    }
  }, [isLoggedIn]);
  console.log('currentUserPermission', currentUserPermission);
  return (
    <div
      style={{
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
      }}>
      {!isLoggedIn && !isLoading ? (
        <div
          style={{
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
          <Authenticator
            services={services}
            hideSignUp
            socialProviders={[]}
            loginMechanisms={['email']}
          />
        </div>
      ) : (
        currentUserPermission && (
          <>
            <Content>
              <SiderComponent />
              <Route exact path="/">
                <Dashboard />
              </Route>
              {(currentUserPermission === 'editor' ||
                currentUserPermission === 'admin') &&
                renderEditorsRoutes()}
              {currentUserPermission === 'admin' && renderAdminRoutes()}

              {currentUserPermission === 'partner' && renderPartnersRoutes()}
              {currentUserPermission === 'CONTENT_CREATOR' &&
                renderContentCreatorRoutes()}

            </Content>
          </>
        )
      )}

      {isLoading && (
        <Space
          direction="vertical"
          style={{
            width: '100%',
            top: '50%',
            backgroundColor: 'red',
            position: 'absolute',
          }}>
          <Spin tip="Loading">
            <div className="content" />
          </Spin>
        </Space>
      )}
    </div>
  );
};
